import { useModal } from 'hooks'

// NOTE: hook that exposes add evaluator modal state
// and handlers for other local hooks and interview components
export const useAddEvaluatorModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleAddEvaluatorClose: handleClose,
    handleAddEvaluatorOpen: handleOpen,
    isAddEvaluatorOpen: isOpen,
  }
}
